import { c as _c } from "react/compiler-runtime";
import Anchor from "@shared-ui/components/Anchor";
import { useState } from "react";
import { T, useGT } from "gt-next";
import { Button } from "../Button";
import { Input } from "@/components/ui/input";
export const EmailAndPassword = t0 => {
  const $ = _c(37);
  const {
    onSubmit,
    view,
    isLoading
  } = t0;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const gt = useGT();
  let t1;
  if ($[0] !== email || $[1] !== onSubmit || $[2] !== password) {
    t1 = event => {
      event.preventDefault();
      onSubmit({
        email,
        password
      });
    };
    $[0] = email;
    $[1] = onSubmit;
    $[2] = password;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = `${view}-email`;
  let t3;
  if ($[4] !== gt) {
    t3 = gt("Email");
    $[4] = gt;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = event_0 => setEmail(event_0.target.value);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== email || $[8] !== isLoading || $[9] !== t2 || $[10] !== t3) {
    t5 = <Input variant="floating" id={t2} name="email" type="email" label={t3} disabled={isLoading} value={email} onChange={t4} autoComplete="email" autoFocus={true} required={true} />;
    $[7] = email;
    $[8] = isLoading;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = `${view}-password`;
  let t7;
  if ($[12] !== gt) {
    t7 = gt("Password");
    $[12] = gt;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = event_1 => setPassword(event_1.target.value);
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = view === "sign-in" ? "current-password" : "new-password";
  let t10;
  if ($[15] !== isLoading || $[16] !== password || $[17] !== t6 || $[18] !== t7 || $[19] !== t9) {
    t10 = <Input variant="floating" id={t6} name="password" type="password" label={t7} disabled={isLoading} value={password} onChange={t8} autoComplete={t9} required={true} minLength={6} maxLength={256} showPasswordToggle={true} />;
    $[15] = isLoading;
    $[16] = password;
    $[17] = t6;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== view) {
    t11 = view === "sign-in" && <div className="flex items-center justify-end"><div className="text-sm"><Anchor href="/forgot-password" className="font-medium text-gray-500 hover:text-gray-700"><T>Forgot password?</T></Anchor></div></div>;
    $[21] = view;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== isLoading || $[24] !== view) {
    t12 = isLoading ? <T>Loading...</T> : view === "sign-in" ? <T>Log in</T> : <T>Get started free</T>;
    $[23] = isLoading;
    $[24] = view;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== isLoading || $[27] !== t12) {
    t13 = <div><Button type="submit" disabled={isLoading} className="text-md shadow-xs focus:outline-hidden flex w-full justify-center border border-transparent px-4 py-3.5 font-medium text-white focus:ring-2">{t12}</Button></div>;
    $[26] = isLoading;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t13 || $[32] !== t5) {
    t14 = <div className="space-y-4">{t5}{t10}{t11}{t13}</div>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t13;
    $[32] = t5;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t1 || $[35] !== t14) {
    t15 = <form method="post" onSubmit={t1}>{t14}</form>;
    $[34] = t1;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};